import { useState } from "react";
import CakeIcon from "@mui/icons-material/Cake";
import EditNoteIcon from "@mui/icons-material/EditNote";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ImageIcon from "@mui/icons-material/Image";
import ScaleIcon from "@mui/icons-material/Scale";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import DialogContent from "@mui/material/DialogContent";
import ChatIcon from '@mui/icons-material/Chat';
const labelStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginBottom: 8,
  color: "#ef8d22",
  fontSize: 14,
  fontWeight: 600,
};

const valueStyle = {
  fontSize: 16,
  fontWeight: 700,
  color: "#122f3b",
  wordBreak: "break-word",
};

const cardStyle = {
  background: "#fff",
  borderRadius: 18,
  padding: 28,
  border: "1px solid #e7e7e7",
  boxShadow: "0 2px 8px rgba(0,0,0,.04)",
};

function Info({ icon, title, value }) {
  return (
    <div>
      <div style={labelStyle}>
        {icon}
        <span>{title}</span>
      </div>

      <div style={valueStyle}>{value || "-"}</div>
    </div>
  );
}

export default function CustomCakeDetails({
  order,
  isMobileScreen,
}) {
  const [previewOpen, setPreviewOpen] = useState(false);

  if (!order) return null;

  return (
    <>
      <div style={{ marginTop: 24, ...cardStyle }}>
        <h2
          style={{
            margin: 0,
            marginBottom: 28,
            fontSize: 24,
            fontWeight: 700,
            color: "#0c5672",
          }}
        >
          Custom Cake Details
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobileScreen
              ? "1fr"
              : "1fr 1fr",
            gap: 28,
          }}
        >
          <Info
            icon={<CakeIcon fontSize="small" />}
            title="Product Selected"
            value={order?.custom_product?.item_name}
          />

          <Info
            icon={<EditNoteIcon fontSize="small" />}
            title="Request on Cake"
            value={order?.description}
          />

          <Info
            icon={<ChatIcon fontSize="small" />}
            title="Message on Cake"
            value={order?.message}
          />

          <Info
            icon={<LocalShippingIcon fontSize="small" />}
            title="Delivery Type"
            value={order?.delivery_type}
          />

          <Info
            icon={<ScaleIcon fontSize="small" />}
            title="Quantity"
            value={`${order?.quantity || "-"} ${order?.quantity_unit || ""}`}
          />

          <div>
            <div style={labelStyle}>
              <ImageIcon fontSize="small" />
              <span>Design Reference</span>
            </div>

            {order?.custom_image ? (
              <img
                src={order.custom_image}
                alt="Cake Design"
                onClick={() => setPreviewOpen(true)}
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  borderRadius: 12,
                  border: "1px solid #ddd",
                  cursor: "pointer",
                  transition: ".25s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
            ) : (
              <div
                style={{
                  width: 120,
                  height: 120,
                  border: "1px dashed #ccc",
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#999",
                }}
              >
                No Image
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Image Preview */}
  <Dialog
  open={previewOpen}
  onClose={() => setPreviewOpen(false)}
  maxWidth="md"
>
  <IconButton
    onClick={() => setPreviewOpen(false)}
    sx={{
      // position: "absolute",
      // top: 8,
      // right: 8,
      
      // zIndex: 10,
    }}
  >
    <CloseIcon />
  </IconButton>

  <DialogContent
    sx={{
      p: 1,
      
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <img
      src={order?.custom_image}
      alt="Preview"
      style={{
        maxWidth: "100%",
        maxHeight: "80vh",
        borderRadius: 8,
      }}
    />
  </DialogContent>
</Dialog>
    </>
  );
}